function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFootballOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 192,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 32
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256 175.15 179.91 238.98 200 320 256 320 312 320 332.09 238.98 256 175.15",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 32
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "332.09 238.98 384.96 216.58 410.74 143.32",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 32
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 447,
    y1: 269.97,
    x2: 384.96,
    y2: 216.58,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 32
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "179.91 238.98 127.04 216.58 101.26 143.32",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 32
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65,
    y1: 269.97,
    x2: 127.04,
    y2: 216.58,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 32
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "256 175.15 256 117.58 320 74.94",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 32
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 192,
    y1: 74.93,
    x2: 256,
    y2: 117.58,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 32
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "312 320 340 368 312 439",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 32
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.74,
    y1: 368,
    x2: 342,
    y2: 368,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 32
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "200 320 172 368 200.37 439.5",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 32
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.63,
    y1: 368,
    x2: 172,
    y2: 368,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 32
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootballOutline);
export default __webpack_public_path__ + "static/media/football-outline.166e06b2458c2085d30be4a3d4436b0f.svg";
export { ForwardRef as ReactComponent };